import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Observable } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { SMSI18NModule } from '../../../assets/i18n/sms-i18n.module';
import { A2PRegistrationService } from '../a2p-registration.service';
import { RegistrationStage } from '../a2p-registration.constants';
import { LearnMoreModalComponent } from '../info-banner/learn-more-modal/learn-more-modal.component';

@Component({
  selector: 'sms-registration-error-banner',
  imports: [CommonModule, GalaxyAlertModule, TranslateModule, SMSI18NModule],
  templateUrl: './sms-registration-error-banner.component.html',
  styleUrls: ['./sms-registration-error-banner.component.scss'],
})
export class SmsRegistrationErrorBannerComponent implements OnInit {
  registrationStage$: Observable<RegistrationStage>;

  protected readonly RegistrationStage = RegistrationStage;

  constructor(
    private smsRegistrationService: A2PRegistrationService,
    private dialog: MatDialog,
  ) {}

  ngOnInit() {
    this.registrationStage$ = this.smsRegistrationService.registrationStage$;
  }
  openLearnMoreModal(): void {
    this.dialog.open(LearnMoreModalComponent, { width: '600px' });
  }
}
